import axiosInstance from '../../utils/axios';

export interface TotalLeadsPayload {
  fromDate?: string;
  toDate?: string;
  stageIds?: string[];
  counsellorIds?: string[];
  sourceIds?: string[];
  page: number;
  pageSize: number;
  sortColumn?: string;
  sortDirection?: "asc" | "desc";
}

export const fetchTotalLeadsReport = (payload: TotalLeadsPayload) => {
  return axiosInstance.post(
    "/api/Reports/reports/leads/total",
    payload
  );
};

export interface AllocationReportPayload {
  fromDate?: string | null;
  toDate?: string | null;
  agentId?: string | null;
  filterAgentId?: string | null;
  pageNumber?: number;
  pageSize?: number;
  search?: string | null;
  sortColumn?: string | null;
  sortDirection?: string | null;
}

// Used for both summary (no agentId) and drill-down (agentId set)
export const fetchLeadAllocationReport = (payload: AllocationReportPayload) => {
  return axiosInstance.post('/api/Reports/GetLeadAllocationReport', payload);
};

export interface AllocationExportPayload {
  fromDate?: string | null;
  toDate?: string | null;
  filterAgentId?: string | null;
  search?: string | null;
}

export const fetchLeadAllocationReportExport = (payload: AllocationExportPayload) => {
  return axiosInstance.post('/api/Reports/GetLeadAllocationReportExport', payload);
};

export interface LeadSourceReportPayload {
  fromDate?: string | null;
  toDate?: string | null;
  agentId?: string | null;
  leadSourceId?: string | null;
  leadSourceFormId?: string | null;
  pageNumber?: number;
  pageSize?: number;
  search?: string | null;
  sortColumn?: string | null;
  sortDirection?: string | null;
  stageIds?: string[] | null;
  subStageIds?: string[] | null;
}

// Used for both summary (no leadSourceId) and drill-down (leadSourceId set)
export const fetchLeadSourceReport = (payload: LeadSourceReportPayload) => {
  return axiosInstance.post('/api/Reports/GetLeadSourceReport', payload);
};

export interface LeadStatusReportPayload {
  fromDate?: string | null;
  toDate?: string | null;
  agentId?: string | null;
  stageIds?: string[] | null;
  subStageIds?: string[] | null;
  pageNumber?: number;
  pageSize?: number;
  search?: string | null;
  sortColumn?: string | null;
  sortDirection?: string | null;
}

export const fetchLeadStatusReport = (payload: LeadStatusReportPayload) => {
  return axiosInstance.post('/api/Reports/GetLeadStatusReport', payload);
};

export interface StatusExportPayload {
  fromDate?: string | null;
  toDate?: string | null;
  agentId?: string | null;
  stageIds?: string[] | null;
  subStageIds?: string[] | null;
}

export const fetchLeadStatusReportExport = (payload: StatusExportPayload) => {
  return axiosInstance.post('/api/Reports/GetLeadStatusReportExport', payload);
};

export interface SourceExportPayload {
  fromDate?: string | null;
  toDate?: string | null;
  agentId?: string | null;
  leadSourceId?: string | null;
  filterLeadSourceId?: string | null;
  search?: string | null;
  stageIds?: string[] | null;
  subStageIds?: string[] | null;
}

export const fetchLeadSourceReportExport = (payload: SourceExportPayload) => {
  return axiosInstance.post('/api/Reports/GetLeadSourceReportExport', payload);
};

export const fetchReportLeadSourcesFilter = () => {
  return axiosInstance.get('/api/Reports/GetReportLeadSourcesFilter');
};